import { createSelector } from '@ngrx/store';
import { collectionTypeState } from '../root';

export const getOrderTypeId = createSelector(collectionTypeState, (collectionType) => collectionType?.orderTypeId);
